import createMatchListPage from "../components/MatchListPage";
import { defaultTransform } from "../hooks/useMatchEndpoint";

const normalizeStatus = (value?: string | null) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "")
    .trim();

export default createMatchListPage({
  getEndpoint: () => "/bureau/profiles/all?filter=callback",
  getHeaderTitle: () => "Call Back Profiles",
  emptyMessage: "No call back profiles found right now.",
  hideCounterFilters: true,
  hideMobileGnavbar: true,
  transform: (payload) =>
    defaultTransform(payload).filter(
      (match) => normalizeStatus(match.followUpStatus) === "callback",
    ),
  buildExtraActions: ({ match, updateFollowUpStatus, updatePaymentStatus }) => {
    const currentStatus = normalizeStatus(match.followUpStatus);

    return [
      {
        id: "callback",
        label: "Move to Call Back",
        onClick: () => updateFollowUpStatus(match, "callback"),
        disabled: currentStatus === "callback",
        className:
          currentStatus === "callback"
            ? "bg-amber-100 text-amber-800 border border-amber-200"
            : "border border-amber-200 text-amber-700 hover:bg-amber-50",
        mobileClassName:
          currentStatus === "callback"
            ? "bg-amber-100 text-amber-800 border border-amber-200"
            : "bg-amber-500 text-white hover:bg-amber-600",
      },
      {
        id: "not_responding",
        label: "Move to Not Responding",
        onClick: () => updateFollowUpStatus(match, "not_responding"),
        className: "border border-rose-200 text-rose-700 hover:bg-rose-50",
        mobileClassName: "bg-rose-600 text-white hover:bg-rose-700",
      },
      {
        id: "paid",
        label: "Move to Paid",
        onClick: () => updatePaymentStatus(match, "paid"),
        className: "border border-green-200 text-green-700 hover:bg-green-50",
        mobileClassName: "bg-green-600 text-white hover:bg-green-700",
      },
      {
        id: "free",
        label: "Move to Free",
        onClick: () => updatePaymentStatus(match, "free"),
        className: "border border-blue-200 text-blue-700 hover:bg-blue-50",
        mobileClassName: "bg-blue-600 text-white hover:bg-blue-700",
      },
      {
        id: "redzone",
        label: "Move to Red Zone",
        onClick: () => updatePaymentStatus(match, "redzone"),
        className: "border border-red-200 text-red-700 hover:bg-red-50",
        mobileClassName: "bg-red-600 text-white hover:bg-red-700",
      },
    ];
  },
});
